module.exports = __webpack_public_path__ + "static/media/contract.e667f86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/contract.png
// module id = 299
// module chunks = 0